/**
 * Middleware to handle location-based redirects for canonical URLs
 * - Redirects mismatched location slugs to normalized format (e.g., st-louis-mo -> saint-louis-mo)
 * - Redirects invalid location slugs by removing them from the URL
 */
export default function withLocationRedirect() {
    return async (ctx, next) => {

        // Redirect #1: redirect to valid location URLs
        // Example: /dealers/st-louis-mo -> /dealers/saint-louis-mo (API returns 'Saint Louis')
        if (ctx.data.hasLocationPath && ctx.data.originalLocation && ctx.query.city && ctx.query.state) {
            // Remove special characters from city name, then replace spaces with hyphens
            const cleanCity = ctx.query.city.toLowerCase().replace(/[^\w\s]/g, '').replace(/\s+/g, '-');
            const normalCityState = `${cleanCity}-${ctx.query.state.toLowerCase()}`;

            if (ctx.data.originalLocation !== normalCityState) {
                const redirectUrl = ctx.req.originalUrl.replace(ctx.data.originalLocation, normalCityState);
                ctx.res.redirect(301, redirectUrl);
                ctx.res.end();
                return;
            }
        }

        // Redirect #2: Remove invalid location segments from URL
        // Example: /dealers/invalid-location-zz -> /dealers
        if (!ctx.data.hasLocationPath && ctx.data.originalLocation) {
            const redirectUrl = ctx.req.originalUrl.replace(`/${ctx.data.originalLocation}`, '');
            ctx.res.redirect(301, redirectUrl);
            ctx.res.end();
            return;
        }

        // No redirect needed - continue to next middleware
        if (next) {
            await next();
        }
    };
}
